import strings from 'strings';

const COPIES = strings.inventoryProfiles.sections.tabs.dataSheet;

const buildPeriod = fromTo => {
  if (!fromTo) return null;

  const { from, to } = fromTo;
  if (!from && !to) return null;

  if (!from) return to;
  const toStr = to || COPIES.period.present;
  return `${from} - ${toStr}`;
};

export const formatDatasheetResponse = data => {
  const formattedData = {
    ...data,
    candidateBackground: {
      ...data?.candidateBackground,
      educationItems: data?.candidateBackground?.educationItems?.map(education => ({
        ...education,
        period: buildPeriod(education?.fromTo),
        title:
          education?.degreeMajor?.degree || education?.degreeMajor?.major
            ? strings.formatString(COPIES.sections.education.degreeAndMajor, {
                degree: education?.degreeMajor?.degree || '',
                major: education?.degreeMajor?.major || ''
              })
            : null,
        subtitle: education?.school || null,
        description: education?.description || null
      })),
      employmentHistoryItems: data?.candidateBackground?.employmentHistoryItems?.map(
        experience => ({
          ...experience,
          period: buildPeriod(experience?.fromTo),
          title: experience?.companyTitle?.title || null,
          subtitle: experience?.companyTitle?.company || null,
          description:
            experience?.dutiesAndResponsibilities || experience?.accomplishments
              ? strings.formatString(COPIES.sections.experience.description, {
                  dutiesAndResponsibilities: experience.dutiesAndResponsibilities || '',
                  accomplishments: experience.accomplishments || ''
                })
              : null
        })
      ),
      licensesAndCertificationsItems:
        data?.candidateBackground?.licensesAndCertificationsItems?.map(item => ({
          ...item,
          title: item?.name || null,
          subtitle: item?.issuingOrganization || null,
          period: buildPeriod({
            from: item?.issueAndExpirationDate?.issueDate,
            to: item?.issueAndExpirationDate?.expirationDate
          })
        }))
    },
    professionalInsights: {
      ...data?.professionalInsights,
      languages: data?.professionalInsights?.languages?.map(language => ({
        ...language,
        name: language?.title || language?.language || null
      }))
    }
  };

  return { ...data, ...formattedData };
};
